const { map } = require('lodash');

class HoverMenuService {
    getDir(menu, submenu) {
        const menuOffset = menu.offset();
        const submenuOffset = submenu.offset();

        const topDiff = Math.abs(menuOffset.top - submenuOffset.top);
        const leftDiff = Math.abs(menuOffset.left - submenuOffset.left);

        if (topDiff > leftDiff) {
            return menuOffset.top > submenuOffset.top ? 'up' : 'down';
        }
        return menuOffset.left > submenuOffset.top ? 'left' : 'right';
    }

    getHoverCone(event, el, dir) {
        // Determine rotation required
        const rotation = this._getRotation(dir);

        // Get important coordinates
        const { bl, br, m } = this._getPoints(event, el, rotation);

        // Get line formula
        const { left, right, centre } = this._getLineFormula(bl, br, m);

        return (x, y) => {
            // Transform cursor position into rotated space
            const c = this._rotate(this._removeOffset({ x, y }, el), rotation);
            // Get y value from appropriate line
            const lineY = (c.x === m.x ? centre : c.x < m.x ? left : right)(c);
            // If we are above this y value we are within the cone
            return c.y >= lineY;
        };
    }

    _getRotation(dir) {
        if (dir === 'up') {
            return Math.PI;
        }
        if (dir === 'left') {
            return -Math.PI / 2;
        }
        if (dir === 'right') {
            return Math.PI / 2;
        }
        return 0;
    }

    _removeOffset(coord, el) {
        return { x: coord.x - el.offset().left, y: coord.y - el.offset().top };
    }

    _rotate(coords, rotation) {
        return {
            x: Math.cos(rotation) * coords.x - Math.sin(rotation) * coords.y,
            y: Math.sin(rotation) * coords.x + Math.cos(rotation) * coords.y,
        };
    }

    _getPoints(event, el, rotation) {
        const originalCoords = [
            { x: 0, y: 0 }, // TL
            { x: el.width(), y: 0 }, // TR
            { x: el.width(), y: el.height() }, // BR
            { x: 0, y: el.height() }, // BL
        ];

        const transformedCoords = map(originalCoords, c => this._rotate(c, rotation));

        // Rotated point coordinates
        const coords = this._rotateArray(transformedCoords, rotation);

        const m = this._rotate(this._removeOffset({ x: event.clientX, y: event.clientY }, el), rotation);

        return {
            bl: coords[3],
            br: coords[2],
            m,
        };
    }

    _getLineFormula(bl, br, m) {
        let lc = 0, rc = 0;

        const left = c => this._line(bl, m, c.x, lc);
        const right = c => this._line(m, br, c.x, rc);
        const centre = () => m.y;

        // Determine the correct y intercepts
        lc = m.y - left(m);
        rc = m.y - right(m);

        return { left, right, centre };
    }

    _rotateArray(arr, rotation) {
        return arr.slice(-rotation / (Math.PI / 2), arr.length).concat(arr.slice(0, -rotation / (Math.PI / 2)));
    }

    _line(c1, c2, x, c) {
        // Definition of a line
        return (c2.y - c1.y) / (c2.x - c1.x) * x + c;
    }
}

module.exports = HoverMenuService;



// WEBPACK FOOTER //
// ./src/olycommon/hovermenu/hovermenu.service.js